module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAALNJREFUKFPdkTEKwkAQRf/OFLaWCnaKJxBrDxCG7B3EnEkRPMKSJa030AuIVgp6iZmVCIGgEayd6g/8NwP/O7xNCGFORHsi6qlqkef5rm1xZVlenXOjd7BrTyndXAhhzMxnAEszO3UZiWgKYKuqE1cbYoxJVWfe+2P90cwW3vtLowH0mfkgIu4DaMONro/+NfBrSncAG1WNXT0wswBYicjwFWtVVWJmawCDL40/iKjIsiw+ASeu1DNtfy0LAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/statics/remove.png
// module id = YP2y
// module chunks = 1